import React, { useState,useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { ParentsMenus } from "../../components/recoil/atoms/Menus";

import HeaderUserTitle from "../components/includes/HeaderUserTitle";

import sampleIcon from "../../img/certi-sample.png";
import "../../css/style.css";

//수료증 상세 보기
const CertificateView = () => {
  let { ce_idx } = useParams();

  const [varParentMenus,setParentMenus] = useRecoilState(ParentsMenus);
  const [varCerficationFile,setCerficationFile] = useState(sampleIcon);
  const [varCertificationData,setCertificationData] = useState({});

  //수료증 상세 보기를 위한 정보 호출
  const GetCertificateIssue = async() => {
    const sendData = {ce_idx:ce_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_certificate_issue`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.certificates.length > 0) {
          const certificates = datas.certificates[0];
          setCertificationData(certificates);
          if(certificates.ce_issue === 1) {
            setCerficationFile(`${process.env.REACT_APP_HOST}/certificate/${certificates.ce_file}`);
          }
        }
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varParentMenus);
    setParentMenus({showMenu:false,gotoMain:0});
    //서버로부터 정보 호출
    GetCertificateIssue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="vh-content">
      <HeaderUserTitle varPageTitle={'수료증 상세'} varBackString={'/Parents/Certificates'}/>
      <div className="vh-content-body cl-certi-wrap">
        <div className="view-con">
          <div className="center-wrap">
            {/* 수료증 표시 */}
            <div className={varCertificationData.ce_lang===1?"img-box":"rotate-img-box"}>
              <img src={varCerficationFile} alt="수료증" />
            </div>
          </div>
        </div>
      </div>
    </div>	
  );
}
export default CertificateView;